import React, { Component } from 'react';

import { styled } from 'styled-components';

import { ErrorBoundaryProps } from 'components/ErrorBoundary/ErrorBoundary';

import { isLivePreviewEnabled } from 'utils/featureFlags';

interface ErrorBoundaryState {
  hasError: boolean;
  clonedChildren?: React.ReactNode;
}

const ErrorMessageBlock = styled.div`
  display: flex;
  justify-content: center;
  border: 0.125rem solid red;
  margin: 0.5rem 1rem;
  font-weight: bold;
  padding: 0.5rem 0;
`;

export class LivePreviewErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    const errorMessage = isLivePreviewEnabled
      ? `${this.props.componentName || 'Component'} can't be displayed. Some required fields are not filled.`
      : 'Sorry there was an error on this page. Please reload the page.';

    if (this.state.hasError) {
      return (
        <ErrorMessageBlock>
          <span>{errorMessage}</span>
        </ErrorMessageBlock>
      );
    }

    return this.props.children;
  }
}
